import { render, staticRenderFns } from "./CartaList.vue?vue&type=template&id=3f91c480&scoped=true&"
import script from "./CartaList.vue?vue&type=script&lang=js&"
export * from "./CartaList.vue?vue&type=script&lang=js&"
import style0 from "./CartaList.vue?vue&type=style&index=0&id=3f91c480&lang=scss&scoped=true&"
import style1 from "./CartaList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91c480",
  null
  
)

export default component.exports